import { render } from "./addSelfOpportunity.vue?vue&type=template&id=045720da&scoped=true"
import script from "./addSelfOpportunity.vue?vue&type=script&lang=js"
export * from "./addSelfOpportunity.vue?vue&type=script&lang=js"

import "./addSelfOpportunity.vue?vue&type=style&index=0&id=045720da&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045720da"]])

export default __exports__